import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NgbDropdown, NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { DocumentModel } from 'src/app/models/document.model';
import { BehaviorSubject, Subscription, tap, pipe, combineLatest } from 'rxjs';
import { DocumentService } from 'src/app/services/document.service';
import { DialogService } from 'src/app/services/dialog.service';
import { TextControlService } from 'src/app/services/text-control.service';
import { InputPositionChangedEvent, SelectionPosition } from 'src/app/services/text-control.service.interface';
import { SnippetAddDialogComponent } from '../../dialogs/snippet-add-dialog/snippet-add-dialog.component';
import { SnippetListDialogComponent } from '../../dialogs/snippet-list-dialog/snippet-list-dialog.component';
import { TextControlContext } from 'textcontrol-promises-develop';
import { ToastService } from 'src/app/services/toast.service';

declare const TXTextControl: any;

@Component({
  selector: 'tx-section-snippets',
  templateUrl: './section-snippets.component.html',
  styleUrls: ['./section-snippets.component.scss'],
})
export class SectionSnippetsComponent implements OnInit, OnDestroy {
  @ViewChild('snippetMenu') snippetMenu!: NgbDropdown;
  @ViewChild('snippetListDialog') snippetListDialog!: SnippetListDialogComponent;
  public textSelected = false;
  public interactiveMode = true;
  private subscriptions = new Subscription();
  private document!: DocumentModel | null;
  private selection: SelectionPosition = { start: 0, length: 0 };
  private InputPosition: InputPositionChangedEvent = { column: 0, line: 0, page: 0, section: 0, textPosition: 0 };
  public startPosition: number = 0;
  public textPartLength: number = 0;

  constructor(
    private documentService: DocumentService,
    private dialogService: DialogService,
    private changeDetector: ChangeDetectorRef,
    public textControlService: TextControlService,
    private toastService: ToastService
  ) {}

  ngOnInit(): void {
    var sub = combineLatest([
      this.textControlService.watchDocumentAndSelectionChangeObservable(),
      this.textControlService.position$,
    ]).subscribe((event) => {
      //this.position = event[1];
      this.selection = event[0].selection;
      this.InputPosition = event[0].position;
      this.textSelected = this.selection.length != 0;
      this.changeDetector.detectChanges();
    });
    this.initializeClientsMenu();
  }
  initializeClientsMenu() {}

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
  toggleInteractive() {
    this.interactiveMode = !this.interactiveMode;
  }

  public addSnippet() {
    // if (!this.textSelected) {
    //   return;
    // }
    const modalRef = this.dialogService.openCustomDialog('addSnippet', SnippetAddDialogComponent, {
      size: 'md',
      backdrop: 'static',
    });
    const modalInstance = modalRef.componentInstance;

    modalRef.result.then(
      (res) => {
        TXTextControl.focus();
        //Done Saved in Modal...
      },
      (res) => {
        TXTextControl.focus();
        //Close button clicked
      }
    );
  }
  toggleListMenu() {
    this.snippetMenu?.toggle();
    this.snippetListDialog.refreshSnippets();
  }
  listSnippets() {}
}
//
